import { createSelector } from 'reselect';

import { RootState } from '../models';

export const selectIsControlBarVisible = createSelector(
  (state:RootState) => state.context.isUserActive,
  (state: RootState) => state.video.isPlaying, 
  (isUserActive: boolean, isPlaying: boolean) => isUserActive || !isPlaying
);